import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {TopelevenPlayer} from 'app/components/topEleven/TopElevenPlayer';
import {SIZES, Typography} from '@fupa/fupa-uikit';
import {getTopEleven} from 'app/services/api';

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  flex-direction: column;

  @media only screen and (min-width: 72.375rem) {
    width: 7.875rem;
  }
`;

const CardHeader = styled.div`
  width: 100%;
  padding: ${SIZES['16']};
  display: flex;
  flex-direction: column;
`;

const Players = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: ${SIZES['16']};
`;

const ScalingTypography = styled(Typography)`
  &&& {
    margin: 0;
    @media only screen and (min-width: 492px) {
      font-size: ${SIZES['20']};
    }
  }
`;

export const SubstitutesCard = ({id, texts}) => {
  const [isFetching, setIsFetching] = useState(true);
  const [substitutes, setSubstitutes] = useState([]);
  const [lastModifiedDate, setLastModifiedDate] = useState('');

  useEffect(() => {
    getTopEleven(id).then((response) => {
      setIsFetching(false);
      setSubstitutes(response.data.topEleven);
      setLastModifiedDate(response.data.lastModified);
    });
  }, []);

  const formatDate = (date) => {
    let formatedDate = new Date(date);
    let options = {year: 'numeric', month: '2-digit', day: '2-digit'};

    return formatedDate.toLocaleString('de-DE', options);
  };

  return (
    <Wrapper substitutes={id > 2}>
      <CardHeader>
        <ScalingTypography variant='subheading' component='h3'>
          {texts.header}
        </ScalingTypography>
        <Typography variant='caption1'>Stand: {formatDate(lastModifiedDate)}</Typography>
      </CardHeader>
      <Players>
        {!isFetching && substitutes.length
          ? substitutes.map((player) => <TopelevenPlayer key={player.player.slug} player={player} substitute={true} />)
          : null}
      </Players>
    </Wrapper>
  );
};
